var _g, _g2, _rect, _rect2, _circle, _g3, _circle2, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContentLoadingMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 82,
    viewBox: "0 0 300 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10332_16027)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 8,
    width: 280,
    height: 60,
    rx: 2,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10332_16027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258 27H274C274.265 27 274.52 27.1054 274.707 27.2929C274.895 27.4804 275 27.7348 275 28V44C275 44.2652 274.895 44.5196 274.707 44.7071C274.52 44.8946 274.265 45 274 45H258C257.735 45 257.48 44.8946 257.293 44.7071C257.105 44.5196 257 44.2652 257 44V28C257 27.7348 257.105 27.4804 257.293 27.2929C257.48 27.1054 257.735 27 258 27ZM265.003 40L272.073 32.929L270.659 31.515L265.003 37.172L262.174 34.343L260.76 35.757L265.003 40Z",
    fill: "#121B2E"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 24,
    width: 107,
    height: 8,
    rx: 3.4,
    fill: "#EBEBEF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 40,
    width: 59,
    height: 8,
    rx: 3.4,
    fill: "#EBEBEF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 38,
    r: 21,
    fill: "#EBEBEF"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10332_16027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43 28C48.52 28 53 32.48 53 38C53 43.52 48.52 48 43 48C37.48 48 33 43.52 33 38C33 32.48 37.48 28 43 28ZM37.023 41.416C38.491 43.606 40.695 45 43.16 45C45.624 45 47.829 43.607 49.296 41.416C47.6317 39.8606 45.4379 38.9968 43.16 39C40.8817 38.9966 38.6875 39.8604 37.023 41.416ZM43 37C43.7956 37 44.5587 36.6839 45.1213 36.1213C45.6839 35.5587 46 34.7956 46 34C46 33.2044 45.6839 32.4413 45.1213 31.8787C44.5587 31.3161 43.7956 31 43 31C42.2044 31 41.4413 31.3161 40.8787 31.8787C40.3161 32.4413 40 33.2044 40 34C40 34.7956 40.3161 35.5587 40.8787 36.1213C41.4413 36.6839 42.2044 37 43 37Z",
    fill: "#09121F"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 10,
    r: 10,
    fill: "#121B2E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.20827 14.168V13.0259L12.2381 10.0558C12.5279 9.76314 12.7694 9.5032 12.9625 9.27592C13.1557 9.04865 13.3006 8.82848 13.3972 8.61541C13.4938 8.40234 13.5421 8.17507 13.5421 7.93359C13.5421 7.65803 13.4796 7.42223 13.3546 7.22621C13.2296 7.02734 13.0577 6.87393 12.839 6.76598C12.6202 6.65803 12.3716 6.60405 12.0932 6.60405C11.8063 6.60405 11.5549 6.66371 11.339 6.78303C11.123 6.8995 10.9554 7.0657 10.8361 7.28161C10.7196 7.49751 10.6614 7.75462 10.6614 8.05291H9.15714C9.15714 7.49893 9.28356 7.0174 9.5364 6.60831C9.78924 6.19922 10.1373 5.88246 10.5804 5.65803C11.0265 5.43359 11.5378 5.32138 12.1145 5.32138C12.6998 5.32138 13.214 5.43075 13.6571 5.6495C14.1003 5.86825 14.4441 6.16797 14.6884 6.54865C14.9355 6.92933 15.0591 7.36399 15.0591 7.85263C15.0591 8.17933 14.9966 8.50036 14.8716 8.8157C14.7466 9.13104 14.5265 9.48047 14.2111 9.86399C13.8986 10.2475 13.4597 10.712 12.8944 11.2575L11.3901 12.7873V12.8469H15.1912V14.168H9.20827Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10332_16027",
    x: 0,
    y: 2,
    width: 300,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.105882 0 0 0 0 0.180392 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10332_16027"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10332_16027",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10332_16027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(254 24)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10332_16027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(31 26)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentLoadingMobile);
export default __webpack_public_path__ + "static/media/content_loading_mobile.c3548ebe98feeac64387425dc1a3960b.svg";
export { ForwardRef as ReactComponent };